import React, {Fragment, memo, useCallback} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import Block from '../block';
import ImageGalleryGallery, {renderDefaultCaption} from '../image-gallery';
import IntlString, {intlString} from '../intl-string';

import style from './image-gallery.module.scss';

export default memo(
	/**
	 * @param {{
	 *   title: null | undefined | import("../../../tmp/graphql-types").IntlStringFragment,
	 *   addDownloadLink: boolean | null | undefined,
	 *   entries: import("../../../tmp/graphql-types").PageElementFrag_PageElementImageGallery_Fragment["imageGalleryEntries"],
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function ImageGallery({title, addDownloadLink = false, entries}) {
		const intl = useIntl();

		const renderCaption = useCallback(
			/**
			 * @param {import("../../../tmp/graphql-types").PageElementFrag_PageElementImageGallery_Fragment["imageGalleryEntries"][number]} entry
			 * @returns {React.ReactElement} ...
			 */
			(entry) => {
				const caption = renderDefaultCaption(entry);

				const download = (() => {
					if (entry.title && entry.local) {
						return `${intlString(intl, entry.title)}${entry.local.ext}`;
					} else {
						return true;
					}
				})();

				return (
					<Fragment>
						{caption}

						{addDownloadLink && entry.local?.publicURL && (
							<Fragment>
								{caption && (
									<br />
								)}

								<FormattedMessage
									id="element.imageGallery.downloadLink"
									values={{
										a(...inner) {
											return (
												<a
													className={style.downloadLink}
													href={entry.local?.publicURL || undefined}
													download={download}
												>
													{inner}
												</a>
											);
										},
									}}
								/>
							</Fragment>
						)}
					</Fragment>
				);
			},
			[addDownloadLink, intl],
		);

		return (
			<Block padding={true}>
				{title && (
					<h1 className={style.title}>
						<IntlString {...title} />
					</h1>
				)}

				<ul className={style.list}>
					{entries.map((entry, i) => (
							<li
								key={i}
								className={style.entry}
							>
								<ImageGalleryGallery
									imageStartIndex={i}
									images={entries}
									renderCaption={renderCaption}
								/>
								<h2 className={style.entryTitle}>
									{entry.title && (
										<IntlString {...entry.title} />
									)}
								</h2>
								<div className={style.entryCaption}>
									{renderCaption(entry)}
								</div>
							</li>
						))}
				</ul>
			</Block>
		);
	}
);
